import { default as config } from "common/config/config";

export default function useHideRegisterRoute(): boolean {
    return config.hideRegisterRoute;
}
